import styles from "./Toggle.module.css";

export function Toggle({ checked, onChange, label, disabled = false, id }) {
  const inputId = id || `toggle-${label?.replace(/\s+/g, "-").toLowerCase()}`;
  return (
    <label className={styles.wrapper} htmlFor={inputId}>
      <span className={styles.label}>{label}</span>
      <span className={styles.track} data-checked={checked} data-disabled={disabled}>
        <input
          id={inputId}
          type="checkbox"
          role="switch"
          aria-checked={checked}
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          className={styles.input}
        />
        <span className={styles.thumb} />
      </span>
    </label>
  );
}
